export enum PractitionerSessionStatus {
    SESSION_STATUS_REQUESTED = 1,
    SESSION_STATUS_ACCEPTED = 2,
    SESSION_STATUS_DECLINED = 3,
    SESSION_STATUS_COMPLETED = 4,
}
